import { el } from 'redom';

import serverInterface from 'server-interface';
import SaveButton from 'generics/components/save-button';

import './content.scss';

class BankAccountVerifierContent {

  constructor(configuration) {

    this.el = el('#bank-account-verifier-body', [
      el('div.description', [el('label', [
        el('span', `Venturz uses Stripe to process payments and keep information secure. You must verify your account to start using Venturz's financial features & services.
        There will be additional 1% procesing fee charged by Venturz on top of Stripe's processing fees. Please review our `),
        el('a', {
          href: 'https://venturz.co/terms',
          target: '_blank'
        }, 'terms'),
        el('span', ' and '),
        el('a', {
          href: 'https://venturz.co/privacy',
          target: '_blank'
        }, 'privacy'),
        el('span', ' for further details. '),
      ])]),
      el('#bank-account-verify-link-container', [
        new SaveButton({
          onClick: this.openVerifyPage.bind(this),
          label: 'Verify account'
        })
      ])
    ]);

  }

  async openVerifyPage(event) {

    const result = await serverInterface.startup.users.banking.getBankAccountStatusByStartupId();

    window.open(result.verificationURL, '_blank');

    return false;

  }

}

export default BankAccountVerifierContent;